module.exports = __webpack_public_path__ + "img/865b095bfec0fa5d3235a932ebcab032.png";